import { useEffect, useState } from "react";
import React from "react";
import { getCircular } from "../Service/Api";
import Breadcrumb from "../Component/Breadcrumb";
import Footer from "../Component/Footer";
import Header from "../Component/Header";
import Menu from "../Component/Menu";
import PageTitle from "../Component/PageTitle";
import LazyLoad from "react-lazyload";

const StudentsAcheivements = () => {
  const [data, setData] = useState([]);
  const [selectedYear, setSelectedYear] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      const galleryData1 = await getCircular();

      // Filter only 'Achievements'
      const filteredData = galleryData1.filter(
        (item) => item.category === "StudentsAchievements",
      );

      // Group by year
      const groupedByYear = filteredData.reduce((acc, item) => {
        const year = new Date(item.date).getFullYear();
        if (!acc[year]) acc[year] = [];
        acc[year].push(item);
        return acc;
      }, {});

      // Sort years descending
      const sortedYears = Object.keys(groupedByYear).sort((a, b) => b - a);

      // Sort each year's data by date descending
      const finalData = sortedYears.map((year) => ({
        year,
        items: groupedByYear[year].sort(
          (a, b) => new Date(b.date) - new Date(a.date),
        ),
      }));

      setData(finalData);

      // Set current year selected by default
      const currentYear = new Date().getFullYear().toString();
      if (groupedByYear[currentYear]) {
        setSelectedYear(currentYear);
      } else if (sortedYears.length > 0) {
        setSelectedYear(sortedYears[0]);
      }
    };

    fetchData();
  }, []);

  const homeMenu = [
    { label: "Vision", link: "/about" },
    {
      label: "Management",
      link: "",
      subMenu: [
        { label: "Director-Principal's Message", link: "/PrincipalMessage" },
        { label: "Leadership Team", link: "/leadershipTeam" },
        { label: "Patron’s Message", link: "/patrons" },
        { label: "Advisory Board", link: "/advisoryBoard" },
      ],
    },
    { label: "International Collaborations", link: "/partnership" },
    // { label: "Awards & Achievements", link: "/awardsAcheivements" },

{
      label: "Awards & Achievements",
      link: "/awardsAcheivements",
      subMenu: [
        { label: "Accolades & Achievements", link: "/awardsAcheivements" },
        { label: "Students Achievements", link: "/studentsAcheivements" },
      ],
    },

    { label: "Faculty", link: "/faculty" },
    { label: "Staff Details", link: "/staffDetails" },
    { label: "School Strength ", link: "/schoolStrength" },
    {
      label: "Gallery",
      link: "/Gallery",
      subMenu: [
        { label: "Photo Gallery", link: "/Gallery" },
        { label: "Video Gallery", link: "/VideoGallery" },
      ],
    },
  ];

  const selectedYearData = data.find((d) => d.year === selectedYear);

  return (
    <>
      <Header />
      <Breadcrumb breadImage="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/banner-awards.jpg" />
      <Menu MenuItem={homeMenu} />
      <div className="padding-blk inner-page">
        <div className="container-fluid">
          <div className="row">
            <div className="col-md-12">
              <PageTitle
                pageTitle="Students Achievements"
                breadEnd="Students Achievements"
                breadMid="Students Achievements"
              />
            </div>
          </div>

          {/* Year Dropdown */}
          <div className="row mb-4 justify-content-center">
            <div className="col-md-4">
              <select
                className="form-select"
                value={selectedYear || ""}
                onChange={(e) => setSelectedYear(e.target.value)}
              >
                {data.map((group) => (
                  <option key={group.year} value={group.year}>
                    {group.year}
                  </option>
                ))}
              </select>
            </div>
          </div>

          {/* Awards Accordion for selected year */}
          <div className="accordion achivements_img_sec" id="awardsAccordion">
            {selectedYearData ? (
              selectedYearData.items.map((item, itemIndex) => (
                <div className="accordion-item mb-3" key={itemIndex}>
                  <h2 className="accordion-header" id={`heading-${itemIndex}`}>
                    <button
                      className={`accordion-button ${
                        itemIndex === 0 ? "" : "collapsed"
                      }`}
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target={`#collapse-${itemIndex}`}
                      aria-expanded={itemIndex === 0 ? "true" : "false"}
                      aria-controls={`collapse-${itemIndex}`}
                    >
                      <i className="bi bi-trophy-fill me-2"></i>
                      {item.title}
                    </button>
                  </h2>
                  <div
                    id={`collapse-${itemIndex}`}
                    className={`accordion-collapse collapse ${
                      itemIndex === 0 ? "show" : ""
                    }`}
                    aria-labelledby={`heading-${itemIndex}`}
                    data-bs-parent="#awardsAccordion"
                  >
                    <div className="accordion-body">
                      <p
                        dangerouslySetInnerHTML={{ __html: item.description }}
                      ></p>

                      {/* Images */}
                      <div className="gallery-images row">
                        {item.images.map((img, imgIndex) => (
                          <div className="col-md-3 mb-3" key={imgIndex}>
                            <a
                              data-magnify="gallery"
                              data-group={`group-${selectedYear}-${itemIndex}`}
                              href={`https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/${img}`}
                            >
                              <LazyLoad>
                                <img
                                  src={`https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/${img}`}
                                  alt={
                                    item?.title ||
                                    "Lotus Valley School, Gurgaon"
                                  }
                                  className="img-fluid rounded mx-auto d-block"
                                />
                              </LazyLoad>
                            </a>
                          </div>
                        ))}
                      </div>

                      {/* Attachments */}
                      {item.attachments.length > 0 && (
                        <div className="attachments mt-2">
                          {item.attachments.map((att, attIndex) => (
                            <a
                              key={attIndex}
                              href={`https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/${att}`}
                              target="_blank"
                              rel="noopener noreferrer"
                              className="d-block mb-1"
                            >
                              Attachment {attIndex + 1}
                            </a>
                          ))}
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              ))
            ) : (
              <p>No awards available for {selectedYear}</p>
            )}
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default StudentsAcheivements;
